import React from 'react';

import { Stack, makeStyles } from '@gogame/components';

const useContainerStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
}));

const useContentStyles = makeStyles(() => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '0 16px',
    maxHeight: 'calc(100vh - 267px)',
    overflowY: 'scroll',
  },
}));

const useFooterStyles = makeStyles((theme) => ({
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: '14px 16px',
  },
}));

export const Container = ({ children }) => {
  const classes = useContainerStyles();
  return <div className={classes.root}>{children}</div>;
};
export const Content = ({ children }) => {
  const classes = useContentStyles();
  return <div className={classes.content}>{children}</div>;
};
export const Footer = ({ children, justifyContent = 'flex-end' }) => {
  const classes = useFooterStyles();
  return (
    <div className={classes.footer}>
      <Stack
        direction={'row'}
        justifyContent={justifyContent}
        alignItems={'center'}
      >
        {children}
      </Stack>
    </div>
  );
};
